import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const BG =
  "https://images.unsplash.com/photo-1527576539890-dfa815648363?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxibGFjayUyMGFuZCUyMHdoaXRlJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwbWluaW1hbHxlbnwwfHx8fDE3Nzk4MjkxNTN8MA&ixlib=rb-4.1.0&q=85";

export default function Philosophy() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      ref={ref}
      className="relative bg-black text-white overflow-hidden border-t border-white/5"
    >
      <motion.div style={{ y }} className="absolute inset-0 -z-0">
        <img
          src={BG}
          alt="Minimal architecture"
          className="w-full h-[120%] object-cover grayscale opacity-25"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/40" />
      </motion.div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-32 md:py-56">
        <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-10">
          §04 — Founder philosophy
        </p>

        <motion.blockquote
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight max-w-[20ch]"
        >
          “We back founders <span className="italic font-light">solving</span> real problems.”
        </motion.blockquote>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-12 md:mt-16 max-w-2xl text-white/70 text-base md:text-xl font-light leading-relaxed"
        >
          We prioritize commercially viable businesses with clear market demand
          and long-term infrastructure potential over trend-driven concepts.
        </motion.p>

        <div className="mt-16 md:mt-20 flex items-center gap-6 text-xs uppercase tracking-[0.3em] text-white/50">
          <span className="h-px w-12 bg-white/30" />
          <span>— The Foundry Thesis</span>
        </div>
      </div>
    </section>
  );
}
